import {useNavigate} from "react-router-dom";
import React from "react";
import styled from "styled-components";

import HorizontalScroll from "react-scroll-horizontal";
import {SHOPIFY_URL} from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";

const StaticWarranty = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed showCart cartIconColor={"#0F475D"} />
      {/*  Body */}

      <Container>
        <HorizontalScroll
          reverseScroll={true}
          style={{ paddingLeft: "100px", paddingRight:"180px", width: "100vw", paddingTop: "100px" }}
        >
          <SecondContainer>
            <Title>warranty</Title>
            <div style={{ display: "flex", gap: "40px", width: "2000px" }}>
              <div style={{ width: "100%" }}>
                <SecondaryTitle>
                  What Are The Details Of Our Warranty Policy?
                </SecondaryTitle>
                <Text>
                  Congratulations on your purchase of an evrbed! We are
                  committed to the quality and durability of your purchase.
                </Text>
                <Text>
                  Quilted Covers are covered under warranty for 5 years for
                  manufacturer defects, including zippers and depressions
                  greater than 1&quot;.
                </Text>
                <Text>
                  Latex Inserts, including slipcovers, are covered under
                  warranty for 5 years for manufacturer defects. Latex Toppers
                  are covered under warranty for depressions greater than
                  3/4&quot;. Photographic evidence may be required. New inserts
                  can be purchased via <b>evrbed.com/XXX</b>
                </Text>
                <Text>
                  If it is determined the toppers failed prematurely, we will
                  provide new components at evrbed&apos;s expense, and will
                  recycle the old insert.
                </Text>
                <Text>
                  Spring units are covered under warranty for 20 years.
                </Text>
                <Text>
                  Evrbed Spring Units are completely covered or repaired for the
                  duration of the warranty. Spring units are covered for broken,
                  loose or depressed coils. The warranty will cover coils or
                  wires that project through the fabric and loose tape edge
                  stitching. Spring units are also covered for depressions
                  greater than 1.5 inches. Zippers on spring units are covered
                  for 5 years, but should last 20 years with regular use. We
                  will repair any Spring unit for any defect if it is delivered
                  to our manufacturing facility. Delivery to evrbed will be at
                  the customers own cost, however, repairs and delivery back to
                  the customer will be evrbed&apos;s responsibility to major
                  centers.
                </Text>
              </div>
              <div style={{ position: "relative" }}>
                <TertiaryTitle>
                  evr-guarantee DOES NOT COVER THE FOLLOWING:
                </TertiaryTitle>
                <Text>
                  Changing comfort preference, as bodies change over time, and
                  what was once comfortable may not be anymore.
                </Text>
                <Text>
                  Structural damage incurred from bending or moving a mattress
                  improperly.
                </Text>
                <Text>Mattress or foundation damage due to abuse.</Text>
                <Text>
                  Soiled or stained mattresses are not covered, as this can
                  damage materials and components within a mattress. New
                  replacement components can be purchased via our shop.
                </Text>
                <Text>
                  Body Indentations less than 1.5 inches — we will fix any
                  issues, but labour and parts charges may apply. If you have
                  any questions or concerns, please contact us.
                </Text>
                <ContainedButton
                  onClick={() => {
                    return (window.top.location.href =
                      SHOPIFY_URL + "pages/contact-us");
                  }}
                >
                  Contact us
                </ContainedButton>
                <LeafDecorator />
                <BlueDecorator />
              </div>
            </div>
          </SecondContainer>
        </HorizontalScroll>
      </Container>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default StaticWarranty;

const Container = styled.div`
  margin: 0 auto;
  //max-width: 1920px;
  height: 90vh;
  padding: 0px 0 0px 0px;
  overscroll-behavior: contain;
  //overflow: auto;
`;
const SecondContainer = styled.div`
  //margin: 0 auto;
  //max-width: 1920px;
  height: 100vh;
  //position: relative;
  //z-index:4000;
  //padding: 100px 0 0px 150px;
  //overscroll-behavior: contain;
  //overflow: auto;
`;

const LeafDecorator = styled.div`
  border-radius: 0 40% 0 40%;
  border: 6px solid #b1d34a;
  width: 7vw;
  height: 17vh;
  position: absolute;
  left: -250px;
  top: -225px;
  opacity: 35%;
  z-index: 99;
`;

const BlueDecorator = styled.div`
  border-radius: 40% 0 40% 0;
  background-color: #abe1fa;
  width: 14vw;
  height: 20vh;
  position: absolute;
  left: -200px;
  top: -180px;
  opacity: 40%;
`;

const Title = styled.h1`
  color: #0f475d;
  font-size: 84px;
  font-family: elena-web-basic;
  font-weight: bold;
  margin-bottom: 32px;
`;

const SecondaryTitle = styled.h2`
  margin-bottom: 32px;
  color: #0f475d;
  font-size: 42px;
  font-family: noto-sans;
  font-weight: bold;
`;

const TertiaryTitle = styled.h3`
  color: #0f475d;
  font-size: 26px;
  font-family: noto-sans;
  font-weight: bold;
`;

const Text = styled.p`
  font-family: noto-sans;
  font-size: 18px;
  color: #0f475d;
  padding-right: 100px;
`;
